// React Query source for incoming shared estimates (estshare__).
// Pending docs only — listMySharedEstimates filters to status=pending.
// Shared by AlertBell (badge count) and useIncomingEstimateAlerts (toasts).

import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { listMySharedEstimates, type SharedEstimateDoc } from '../lib/db/shared'

export function useIncomingSharedEstimates() {
  const { effectiveUid } = useAuth()
  return useQuery<SharedEstimateDoc[]>({
    queryKey: ['incomingSharedEstimates', effectiveUid ?? 'anon'],
    queryFn: () => (effectiveUid ? listMySharedEstimates(effectiveUid) : Promise.resolve([])),
    enabled: !!effectiveUid,
    staleTime: 10_000,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  })
}
